/* SET STATE */
export const SET_STATE_LABSEGMENT = "SET_STATE_LABSEGMENT"

/* LAB SEGMENTS */
export const GET_LABSEGMENTS = "GET_LABSEGMENTS"
export const GET_LABSEGMENTS_SUCCESS = "GET_LABSEGMENTS_SUCCESS"
export const GET_LABSEGMENTS_FAIL = "GET_LABSEGMENTS_FAIL"

/* LAB SEGMENT */
export const GET_LABSEGMENT = "GET_LABSEGMENT"
export const GET_LABSEGMENT_SUCCESS = "GET_LABSEGMENT_SUCCESS"
export const GET_LABSEGMENT_FAIL = "GET_LABSEGMENT_FAIL"

/**
 * ADD LAB SEGMENT
 */
 export const ADD_NEW_LABSEGMENT = "ADD_NEW_LABSEGMENT"
 export const ADD_LABSEGMENT_SUCCESS = "ADD_LABSEGMENT_SUCCESS"
 export const ADD_LABSEGMENT_FAIL = "ADD_LABSEGMENT_FAIL"

 /**
 * UPDATE LAB SEGMENT
 */
export const UPDATE_LABSEGMENT = "UPDATE_LABSEGMENT"
export const UPDATE_LABSEGMENT_STATUS = "UPDATE_LABSEGMENT_STATUS"
export const UPDATE_LABSEGMENT_SUCCESS = "UPDATE_LABSEGMENT_SUCCESS"
export const UPDATE_LABSEGMENT_FAIL = "UPDATE_LABSEGMENT_FAIL"

/**
 * DELETE LAB SEGMENT
 */
export const DELETE_LABSEGMENT = "DELETE_LABSEGMENT"
export const DELETE_LABSEGMENT_SUCCESS = "DELETE_LABSEGMENT_SUCCESS"
export const DELETE_LABSEGMENT_FAIL = "DELETE_LABAREA_FAIL"
